import type { FlightSearchResult } from 'flights/metasearch/flightSearchResult';
import type { NextObserver } from 'rxjs';

export function flightSearchResultObserver(
  onResolve: (flightSearchResult: FlightSearchResult) => void,
  complete?: () => void,
  error?: (err: any) => void,
): NextObserver<FlightSearchResult> {
  return {
    next: (value: FlightSearchResult) => {
      const { fares } = value;

      // Impression log on page load
      if (fares.length) {
        const event = new CustomEvent('onPageLoadLogImpression');

        window.dispatchEvent(event);
      }

      return onResolve(value);
    },
    complete,
    error,
  };
}
